<template>
    <div class="section register wf-section">
    <div id="join-moijoy-container" class="container register">
      <div class="join-us-cta">
        <h1 class="no-top-margin">You&#x27;re a winner.</h1>
        <p>We&#x27;ll be in touch soon. Thanks for your time 🙏</p>
      </div>
    </div>
  </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    data(){
    },
    methods:{
    },
    created(){
      //firebase.auth().signOut();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/thanks.vue